import { tools } from "@game.object/ts-game-toolbox";
import { CanvasView } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/CanvasView";
import { RgbColor } from "@game.object/ts-game-toolbox/dist/src/data/RgbColor";
import { ChainProperty } from "@game.object/ts-game-toolbox/dist/src/signals/ChainProperty";
import { ViewCollection } from "../ViewCollection";
import { Vector2, Vector2I } from "@game.object/ts-game-toolbox/dist/src/geometries/Vector2";
import { string_from_hash, string_with_min_length } from "../../../tools/StringHelper";

interface ViewBlocksAttr {
    previous_hash: number,
    data: string,
    nonce: number,
    hash: number,
    is_valid: boolean,
}

export class MainView extends CanvasView<ViewCollection> {
    public fg_color = new ChainProperty<this, RgbColor>(this, tools.commons.Colors.WHITE);
    public bg_color = new ChainProperty<this, RgbColor>(this, tools.commons.Colors.BLACK);

    public blocks = new ChainProperty<this, Array<ViewBlocksAttr>>(this, []);
    public chained_block_ids = new ChainProperty<this, Array<number>>(this, []);

    public draw(): void {
        this.context.resetTransform();
        this.reset_canvas_state();
        const COLUMNS = Math.ceil(Math.sqrt(this.blocks.get().length));
        const BLOCK_PIXEL_WIDTH = 700 / 5 - 5;
        const BLOCK_PIXEL_HEIGHT = 100 - 5;
        const SCALE = 5 / Math.max(1, COLUMNS);
        const BLOCK_WIDTH = 16;
        const BLOCK_ROWS = 5;
        this.context.translate(50, 50);
        this.context.scale(SCALE, SCALE);
        this.blocks.get().forEach((block, index) => {
            const x = (index % COLUMNS) * 700 / 5;
            const y = 100 * Math.trunc(index / COLUMNS);
            // Border
            this.context.strokeStyle = block.is_valid ? "green" : "red";
            this.context.lineWidth = 6;
            this.context.strokeRect(x - 3, y - 3, BLOCK_PIXEL_WIDTH, BLOCK_PIXEL_HEIGHT);
            // Hash
            this.context.fillStyle = (this.chained_block_ids.get().includes(index))
                ? "yellow"
                : "white";
            this.context.font = "16px monospace";
            this.context.fillText("prev#: " + string_from_hash(block.previous_hash), x, y);
            this.context.fillText("nonce: " + string_from_hash(block.nonce), x, y + 16);
            this.context.fillText("hash : " + string_from_hash(block.hash), x, y + 32);
            // Data
            this.context.font = "10px monospace";
            for (let i = 0; i < block.data.length && i < BLOCK_WIDTH * BLOCK_ROWS; i += BLOCK_WIDTH) {
                const chunk = block.data.slice(i, i + BLOCK_WIDTH);
                this.context.fillText(chunk, x, y + 48 + i);
            }

        });
    }

    /**
     * Reset default canvas state and paint the background
     */
    protected reset_canvas_state() {
        super.reset_canvas_state();
        this.context.fillStyle = this.bg_color.get().to_hex();
        this.context.fillRect(0, 0, 800, 600);
        this.context.fillStyle = this.fg_color.get().to_hex();
        this.context.imageSmoothingEnabled = false;
        this.context.textAlign = "left";
        this.context.textBaseline = "top";

    }
}